import { call, put, takeEvery } from 'redux-saga/effects';
import { questionBankActions } from './questionBankSlice';
import { getQuestionInfo, getById, updateById, create as createQuestion, updateStatusById, getSection, getChapter, getGroup, deleteById as deleteQuestion } from './questionBankBaseApi';
import { toastAction } from '../toast/toast';

export function* onChangeQuestion(payload) {
    try {
        const { data } = yield call(getQuestionInfo, payload);
        yield put(questionBankActions.setQuestionBank(data || {}));
    } catch (error) {
        yield put(questionBankActions.setQuestionBank({}));
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onChangeCourseQuestion(payload){
    try{
        const {data} = yield call(getQuestionInfo,payload);
        yield put(questionBankActions.setCourseQuestion(data || {}));
    }catch(error){
        yield put(questionBankActions.setCourseQuestion({}));
    }
}

export function* onChangeCurrentQuestion({ payload }) {
    try {
        const { data } = yield call(getById, payload);
        yield put(questionBankActions.setCurrentQuestion(data || {}));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message))
    }
}


export function* onSaveCurrentQuestion({ payload }) {
    let { question, navigate } = payload;
    try {
        const { data, message } = yield call(updateById, question);
        yield put(questionBankActions.setCurrentQuestion(data || {}));
        yield put(toastAction.onSuccToast(`Question Bank Update Success`))
        try {
            navigate('/question-bank', { replace: true });
        } catch (e) { }
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onCreateQuestion({ payload }) {
    let { question, navigate } = payload;
    try {
        const { data, message } = yield call(createQuestion, question);
        yield put(toastAction.onSuccToast(`Question Bank Create Success`))
        try {
            navigate('/question-bank', { replace: true });
        } catch (e) { }
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onDeleteQuestion({ payload }) {
    try {
        yield put(questionBankActions.deleteQuestion(payload));

        const { data, message } = yield call(deleteQuestion, payload);
        yield put(toastAction.onSuccToast(message))
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error));
    }
}

export function* onUpdateStatusById({ payload }) {
    try {
        const { data, message } = yield call(updateStatusById, payload);
        yield put(questionBankActions.setCurrentQuestion(data || {}));
        yield put(toastAction.onSuccToast(message))
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error));
    }
}

export function* onChangeSection(payload) {
    try {
        const { data } = yield call(getSection, payload);
        yield put(questionBankActions.setSection(data?.data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}


export function* onChangeChapter(payload) {
    try {
        const { data } = yield call(getChapter, payload);
        yield put(questionBankActions.setChapter(data?.data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}


export function* onChangeGroup(payload) {
    try {
        const { data } = yield call(getGroup, payload);
        yield put(questionBankActions.setGroup(data || {}));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

function* questionBankWatcherSaga() {
    yield takeEvery(questionBankActions.loadQuestionBank.type, onChangeQuestion);
    yield takeEvery(questionBankActions.loadCourseQuestion.type,onChangeCourseQuestion);
    yield takeEvery(questionBankActions.loadCurrentQuestion.type, onChangeCurrentQuestion);
    yield takeEvery(questionBankActions.saveCurrentQuestion.type, onSaveCurrentQuestion);
    yield takeEvery(questionBankActions.createQuestion.type, onCreateQuestion);
    yield takeEvery(questionBankActions.removeQuestion.type, onDeleteQuestion);
    yield takeEvery(questionBankActions.updateStatus.type, onUpdateStatusById);

    yield takeEvery(questionBankActions.loadSection.type, onChangeSection);
    yield takeEvery(questionBankActions.loadChapter.type, onChangeChapter);
    yield takeEvery(questionBankActions.loadGroup.type, onChangeGroup);

}

export default questionBankWatcherSaga;